import { type FC } from 'react';
import { useNavigate } from 'react-router';
import { Avatar, Menu } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useUnit } from 'effector-react';
import { $authInfo, useLogout } from '~/entities/auth';
import { routes } from '~/shared/constants/routes';
import { Items } from './components';
import { links } from './constants';

const success = (message: string) => {
    notifications.show({
        title: 'Успешно',
        message,
        color: 'green',
    });
};

export const ProfileMenu: FC = () => {
    const navigate = useNavigate();

    const { mutate: logout } = useLogout();

    const {
        authInfo: { email = '' },
    } = useUnit({ authInfo: $authInfo });

    const handleLogout = () => {
        logout(undefined, {
            onSuccess: () => {
                success('Вы успешно вышли из аккаунта');
                navigate(routes.auth);
            },
        });
    };

    const items = links(handleLogout);

    return (
        <Menu trigger='hover'>
            <Menu.Target>
                <Avatar
                    src={email}
                    size='md'
                />
            </Menu.Target>

            <Items items={items} />
        </Menu>
    );
};
